'use client';

import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';

import PageLayoutV3 from '@/app/components/PageLayoutV3';

const Content = (): JSX.Element => {
  const selectedLocale = useLocale();
  const t = useTranslations();

  return (
    <PageLayoutV3
      pageName="Privacy Policy"
      containerProps={{ name: 'privacy-policy', padding: 'both' }}
      footerProps={{
        wrapperClassName: 'bg-white',
      }}
    >
      <LayoutGrid data-cy="privacy-policy-page">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3 Element="h1" variant="h3">
            {t('privacy_policy_title')}
          </TypographyV3>
          <TypographyV3 variant="h6" className="mb-8">
            {t('privacy_policy_heading')}
          </TypographyV3>
          <TypographyV3 className="mb-4 underline">
            <Link href={`/${selectedLocale}/privacy-policy-oura-health`}>
              {t('privacy_policy_health_link')}
            </Link>
          </TypographyV3>
          <TypographyV3 className="underline">
            <Link
              href="https://cloud.ouraring.com/legal/teams/privacy-policy"
              target="_blank"
            >
              {t('privacy_policy_teams_link')}
            </Link>
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </PageLayoutV3>
  );
};

export default Content;
